import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { DomSanitizer } from '@angular/platform-browser';

import { ActivatedRoute } from '@angular/router';

import { BusyService } from 'src/app/services/busy.service';

import { GurdServiceService } from 'src/app/services/gurd-service.service';

import { OtherService } from 'src/app/services/other.service';

import axios from "src/app/services/axios";


@Component({

  selector: 'app-full-payment',

  templateUrl: './full-payment.component.html',

  styleUrls: ['./full-payment.component.css']

})

export class FullPaymentComponent implements OnInit {

  href_Android: string = 'return://emdadro';

  bAndroid: boolean = false;

  trip_Obj!: any;

  mdl_Auth: FormGroup = this._fb.group({

    strAuthority: new FormControl(''),

    strStatus: new FormControl(''),

    AppType: new FormControl(''),

    InvoceType: new FormControl(''),

    InvoiceNum: new FormControl(''),

  })

  mdl_Success: FormGroup = this._fb.group({

    ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

  })

  constructor(

    private route: ActivatedRoute,

    private _fb: FormBuilder,

    private _utility: OtherService,

    private gurdService: GurdServiceService,

    private sanitizer: DomSanitizer,

    public loaderService: BusyService,


  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((query: any) => {

      // console.log(query)

      this.mdl_Auth.patchValue({

        strAuthority: query.Authority,

        strStatus: query.Status,

        AppType: query.AppType,

        InvoceType: query.InvoceType,

        InvoiceNum: query.InvoiceNum,


      })

      this.checkOut(query);

    })

    this.route.url.subscribe((segment) => {

      if (segment[1]?.path == 'mobile') {

        this.bAndroid = true;

      }

    })

  }

  checkOut = async (mdl_Query: any) => {

    this.loaderService.busy();

    const resp_2 = await axios.post(`Passenger_CheckPayment`, mdl_Query);

    this.loaderService.idle();

    let res = JSON.parse(resp_2.data);

    console.log(res)

    this.trip_Obj = res;

  }

  openLink() {

    window.open(this.sanitizer.sanitize(4, this.return_SafeUrl(this.trip_Obj.strURL)) || '', "_self")

  }

  return_SafeUrl(url: string) {

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);

  }

}
